// ---------------------------------------------- modules import
import { IAuthState, AuthAction, AuthActionType } from "./common";

const initialState: IAuthState = {
  error: null
};

// ---------------------------------------------- the reducer
const authReducer = (state = initialState, action: AuthAction): IAuthState => {
  switch (action.type) {
    case AuthActionType.LOGIN_SUCCESS: {
      return {
        ...state,
        error: null
      };
    }
    case AuthActionType.LOGIN_ERROR: {
      return {
        ...state,
        error: action.payload.error
      };
    }
    case AuthActionType.LOGOUT_SUCCESS: {
      return {
        ...state,
        error: null
      };
    }
    case AuthActionType.LOGOUT_ERROR: {
      return {
        ...state,
        error: action.payload.error
      };
    }
    default: {
      return state;
    }
  }
};

export default authReducer;
